module.exports = __webpack_public_path__ + "static/img/phyto-res-technology.1f87c506.png";